import { combineReducers } from "@reduxjs/toolkit";
import authReducer from '../slice/authSlice'
import dataReducer from '../slice/dataSlice'
const rootReducer = combineReducers({
    auth: authReducer,
    data:dataReducer
})

export default rootReducer